const sliceName = "event";
const initialState = {
	loading: false,
	history: {}
}

export { sliceName, initialState };